import { useCallback, useState } from 'react'
import classNames from 'classnames'

import Menu from './Menu'
import Navbar from './Navbar'
import useFetch from '../hooks/useFetch'
import useIsMobile from '../hooks/useIsMobile'
import styles from './Header.module.scss'

function Header() {
  const [show, setShow] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [path, setPath] = useState('')
  const isMobile = useIsMobile()

  const handleClose = useCallback(() => {
    setShow(false)
    setPath('')
  }, [])

  const transferData = (resp) => resp.data

  const { data, loading, error } = useFetch('hambergermenu', transferData)

  const handleMenuIconClick = (e, urlPath) => {
    if (urlPath) {
      setPath(urlPath)
      setShow(true)
    } else {
      setShow(!show)
    }
  }

  return (
    <header
      className={classNames(styles.header, {
        [styles.zIndex1200]: show || isModalOpen,
      })}
    >
      <Navbar
        extraMenus={data?.menu_links || []}
        isMenuOpen={show}
        handleClick={handleMenuIconClick}
        className={classNames(styles.navbarStyle)}
        handleClose={handleClose}
        setModalVisibility={setIsModalOpen}
        loading={loading}
        langauges={data?.languages || []}
      />
      {show && (
        <Menu
          selectedPath={!isMobile ? path : ''}
          show={show}
          handleClose={handleClose}
          menus={data?.hambergermenu || []}
          loading={loading}
          error={error}
        />
      )}
    </header>
  )
}

export default Header
